<template>
  <div>
    <page-header
      :actions="headerActionConfig"
      left-side-class="col-xl-5 pb-2"
      :page="headerConfig"
      right-side-class="col-xl-7 d-flex align-items-end pb-4 justify-content-end"
    />

    <question-form :id="id" is-preview is-read-only />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import { getById, changeStatus } from '@/modules/bidQuestionConfig/api.js';
import alert from '@/mixins/alert.mixin';

import { announcementQuestionnaireStatuses } from '@/utils/constants/announcementQuestionnaireStatus';
import QuestionForm from './components/QuestionForm.vue';

export default {
  name: 'QuestionConfigPreview',
  components: {
    PageHeader,
    QuestionForm,
  },
  mixins: [alert],
  data() {
    return {
      questionConfig: {
        sections: [],
      },
    };
  },
  computed: {
    headerConfig() {
      return {
        title: 'Configuración Preguntas para Pliegos',
        icon: 'fas fa-file-invoice',
        routes: [
          'Proceso de Competencias',
          'Configuración Preguntas para Pliegos',
        ],
      };
    },
    headerActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'far fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'questionConfiguration' }),
        },
        {
          text: 'Regresar a Borrador',
          icon: 'fas fa-reply-all',
          variant: 'outline-success',
          visible: this.canRollbackDraft,
          click: () => this.rollbackToDraft(),
        },
        {
          text: 'Publicar',
          icon: 'fas fa-file-check',
          variant: 'success',
          visible: this.isSubmitted,
          click: () => this.publish(),
        },
      ];
    },
    id() {
      const { id } = this.$route.params;
      return Number(id);
    },
    isDraft() {
      return (
        this.questionConfig.status?.id ===
        announcementQuestionnaireStatuses.Draft
      );
    },
    isSubmitted() {
      return (
        this.questionConfig.status?.id ===
        announcementQuestionnaireStatuses.Submitted
      );
    },
    isReadOnly() {
      return [
        announcementQuestionnaireStatuses.Submitted,
        announcementQuestionnaireStatuses.Published,
      ].includes(this.questionConfig.status?.id);
    },
    canRollbackDraft() {
      return this.isSubmitted;
    },
  },
  async mounted() {
    await this.getQuestionConfig();
  },
  methods: {
    async getQuestionConfig() {
      const { data } = await getById(this.id).catch((e) =>
        this.ShowToast('', e?.response?.data?.message, 'error')
      );
      this.questionConfig = data;
    },
    async rollbackToDraft() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea regresar la configuración a borrador?',
        'Si',
        'No'
      );

      if (!confirmed) return;

      try {
        await changeStatus(this.id, announcementQuestionnaireStatuses.Draft);
        this.ShowToast(
          'Proceso exitoso',
          'Los cambios fueron guardados exitosamente',
          'success'
        );

        this.$router.push({
          name: 'questionConfigurationDetail',
          params: { id: this.id },
        });
      } catch (error) {
        this.ShowToast('Error', error.response.data.message, 'error');
        return;
      }
    },
    async publish() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea publicar la configuración <b>${this.questionConfig.number}</b>?`,
        'Sí',
        'No'
      );

      if (!confirmed) return;

      await changeStatus(this.id, announcementQuestionnaireStatuses.Published)
        .then(() => this.getQuestionConfig())
        .catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));

      this.ShowToast(
        'Proceso exitoso',
        'Los cambios fueron guardados exitosamente',
        'success'
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
.section-title > div {
  border: 3px solid white;
  padding: 3px 4px;
  border-radius: 30px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}
</style>
